import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {LineChartData} from "../../../interfaces/line-chart-data";
import Chart, {ActiveElement, ChartEvent} from "chart.js/auto";

@Component({
  selector: 'brt-mini-chart',
  templateUrl: './mini-chart.component.html',
  styleUrls: ['./mini-chart.component.scss']
})
export class MiniChartComponent implements AfterViewInit {
  @ViewChild("miniChart") miniChart!: ElementRef;

  @Input('data') set setData(data: LineChartData) {
    this.data = data;

    if(this.data && this.miniChart) {
      this.renderChart();
    }
  }
  data!: LineChartData;

  currentChart?: Chart;

  renderChart() {
    // console.log(this.data);

    if(this.data.datasets.length === 0) return;

    this.data.datasets = this.data.datasets.filter((el) => el !== null);

    if(this.data.datasets[0].items.length === 0) return;
    if(this.data.datasets[0].items[0] === null) return;

    if(this.currentChart) this.currentChart.destroy();

    const maxValue = [...this.data.datasets[0].items].sort((a, b) => a.value > b.value ? -1 : 1)[0].value;

    this.currentChart = new Chart(
      this.miniChart.nativeElement as HTMLCanvasElement,
      {
        type: 'line',
        options: {
          layout: {
            padding: {
              top: 0,
              bottom: 2
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              display: false
            },
            y: {
              display: false,
              suggestedMax: maxValue,
            }
          },
          onHover: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
          },
          events: [],
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false
            }
          },
          hover: {
            mode: 'nearest',
            intersect: false,
          }
        },
        data: {
          labels: this.data.datasets[0].items.map(row => row.value),
          datasets: [
            {
              label: '',
              data: this.data.datasets[0].items.map(row => row.value),
              tension: 0.4,
              pointRadius: 0,
              borderColor: (context) => {
                const chart = context.chart;
                const {ctx, chartArea} = chart;

                if (!chartArea) {
                  // This case happens on initial chart load
                  return;
                }
                const chartWidth = chartArea.right - chartArea.left;
                const chartHeight = chartArea.bottom - chartArea.top;
                let width;
                let height;
                let gradient;
                if (!gradient || width !== chartWidth || height !== chartHeight) {
                  // Create the gradient because this is either the first render
                  // or the size of the chart has changed
                  const width = chartWidth;
                  const height = chartHeight;
                  gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right,0);
                  gradient.addColorStop(0, this.data.datasets[0].color);
                  gradient.addColorStop(1, this.data.datasets[0].color);
                }

                return gradient;
              }
            }
          ]
        }
      }
    );

  }
  ngAfterViewInit(): void {
    if(this.data) {
      this.renderChart();
    }


  }
}
